<template>
    <component :is="tag" v-bind="linkProps" class="card" @click="handleClick"
               :class="[shadowString && !outlined ? 'shadow-' + shadowString : '', colorString ? 'bg-' + colorString : '', {'mb-8 sm:mb-16': !noSpacing}, responsiveGridBorderRadiusClass, {'is-clickable': isClickable && !disabled, 'card-small': small, 'card-x-small': xSmall, 'border': outlined, 'is-dark': dark}]"
               :style="cardStyle">
        <lazy-progress-bar v-if="isLoading" class="z-1" absolute top :color="loadingColor"/>
        <slot/>
    </component>
</template>

<script>
import Shadowable from "../../mixins/Shadowable";
    import Dimensionable from "../../mixins/Dimensionable";
    import Linkable from "../../mixins/Linkable";
    import CardMixin from "./CardMixin";
    import Hoverable from "../../mixins/Hoverable";
    import Colorable from "../../mixins/Colorable";

    export default {
        name: "Card",
        mixins: [CardMixin, Shadowable, Dimensionable, Linkable, Hoverable, Colorable],

        props: {

            xSmall: {
                type: Boolean,
                default: false
            },

            small: {
                type: Boolean,
                default: false
            },

            // States that the card has a dark background and the text colors shall be lightened up
            dark: {
                type: Boolean,
                default: false
            },

            // A boolean to state whether a medium shadow shall be shown or a specific shadow size string
            shadow: {
                type: [String, Boolean],
                default: true
            },

            // The color of the loading indicator
            loadingColor: {
                type: String,
                default: 'primary'
            }
        },

        computed: {
            tag() {
                if (this.absoluteTo) {
                    return 'a';
                }
                if (this.relativeTo) {
                    return resolveComponent('NuxtLink');
                }

                return 'div';
            },

			cardStyle() {
				const styles = {width: this.widthStyle, maxWidth: this.maxWidthStyle, minWidth: this.minWidthStyle, height: this.heightStyle, maxHeight: this.maxHeightStyle, minHeight: this.minHeightStyle, backgroundColor: this.colorHex}

				// Remove all keys whose value is null or undefined to prevent empty style attributes which would override styles set by directives, e.g., adapt
				Object.keys(styles).forEach(key => [null, undefined].includes(styles[key]) && delete styles[key]);

				return styles;
			}
        }
    }
</script>

<style>
/*********************
  Inputs
**********************/
.app .card {
  color: #465050;
  background-color: #ffffff;
  position: relative;
  outline: none;
  max-width: 100%;
  will-change: box-shadow;
  white-space: normal;
  transition: box-shadow 0.28s cubic-bezier(0.4, 0, 0.2, 1);
  transition-property: box-shadow, opacity;
  word-wrap: break-word;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
}
.app .card > .responsive-image:first-child {
  max-width: 100%;
  min-width: 100%;
}
.app .card.is-clickable:hover {
  cursor: pointer;
  background-color: #fcfcfc;
}
.app .card.is-dark {
  color: #ffffff;
}
</style>